// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  paymentWithLinkedListFormSchema,
  PaymentWithLinkedListValuesType,
  paymentWithLinkedListInitialValues,
} from "./_formTypes";
import { Stack } from "@mui/system";
import {
  FormControl,
  Autocomplete,
  TextField,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Button, Loading, StatusBarTransaction } from "../../atoms";
import { zodResolver } from "@hookform/resolvers/zod";
import { SelectControl, Table, DeleteConfirmModal } from "../../molecules";
import { downloadExcel } from "../../../util/downloadExcel";
import { useUserInfo } from "../../../store/User.state";
import BaseFilterTableWithAccordion from "../../atoms/BaseFilterTableWithAccordion";

import {
  useGetAllMerchantList,
  useGetLinkedPaymentStatusList,
  IPaymentWithLinkedListRequest,
  useGetPaymentWithLinkedList,
  usePassiveLinkedPayment,
  IPaymentWithLinkedListItem,
  useAuthorization,
} from "../../../hooks";
import { PagingResponse } from "../../../hooks/_types";
import {
  GridColDef,
  GridActionsCellItem,
  GridPaginationModel,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import { useSetSnackBar } from "../../../store/Snackbar.state";


function RenderStatus(props: GridRenderCellParams<any, string>) {
  const { value } = props;

  return <>{value && <StatusBarTransaction status={value} />}</>;
}


export const PaymentWithLinkedListFilter = () => {
  const { showDelete, showUpdate } = useAuthorization();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const [userInfo] = useUserInfo();
  const { data: rawMerchantList } = useGetAllMerchantList("ACTIVE");
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const { data: rawLinkedPaymentStatusList } = useGetLinkedPaymentStatusList(
    {}
  );
  const {
    mutate: GetPaymentWithLinkedList,
    isLoading: isGetPaymentWithLinkedListLoading,
  } = useGetPaymentWithLinkedList();
  const {
    mutate: passiveLinkedPayment,
    isLoading: isPassiveLinkedPaymentLoading,
  } = usePassiveLinkedPayment();
  const setSnackbar = useSetSnackBar();
  const [queryOptions, setQueryOptions] = React.useState({});
  const [tableData, setTableData] = useState<
    PagingResponse<IPaymentWithLinkedListItem[]> | undefined
  >();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState();
  const { control, handleSubmit, setValue, watch } =
    useForm<PaymentWithLinkedListValuesType>({
      resolver: zodResolver(paymentWithLinkedListFormSchema),
      defaultValues: paymentWithLinkedListInitialValues,
    });
  const [showTable, setShowTable] = useState(false)
  const merchantID = watch("merchantID");
  const status = watch("status");

  // const merchantList = useMemo(() => {
  //   return rawMerchantList?.data?.map(
  //     (rawPosType: { merchantName: string; merchantId: number }) => {
  //       return {
  //         label: rawPosType.merchantName,
  //         value: rawPosType.merchantId,
  //       };
  //     }
  //   );
  // }, [rawMerchantList?.data]);

  const merchantList = useMemo(() => {

    if (userInfo.merchantId == 0) {
      return rawMerchantList?.data?.map(
        (rawPosType: { merchantName: string; merchantId: number }) => {
          return {
            label: rawPosType.merchantName + ` (${rawPosType.merchantId})`,
            value: rawPosType.merchantId,
          };
        }
      );
    } else {
      return rawMerchantList?.data
        ?.filter((rawPosType: { merchantName: string; merchantId: number }) => {
          return rawPosType.merchantId === Number(userInfo.merchantId);
        })
        .map((filteredMerchant) => {
          return {
            label: filteredMerchant.merchantName + ` (${filteredMerchant.merchantId})`,
            value: filteredMerchant.merchantId,
          };
        });
    }
  }, [rawMerchantList?.data, userInfo?.merchantId]);

  const paymentstatusList = useMemo(() => {
    return rawLinkedPaymentStatusList?.data?.map(
      (merchant: { key: string; value: string }) => {
        return {
          label: `${merchant.value}`,
          value: merchant.key,
        };
      }
    );
  }, [rawLinkedPaymentStatusList?.data]);

  // Status değeri exel için buradan alınıyor 
  function getStatusLabel(statusKey: string) {
    const foundStatus = paymentstatusList?.find((s) => s.value === statusKey);
    return foundStatus ? foundStatus.label : statusKey;
  }




  const [formValues, setFormValues] = useState<IPaymentWithLinkedListRequest | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false)
  const onSubmit = (formValues: PaymentWithLinkedListValuesType) => {
    setFilterAccordionExpand(false);
    setTableData(undefined);
    setShowTable(true)
    const request: IPaymentWithLinkedListRequest = {
      merchantID: formValues.merchantID,
      status: formValues.status,
      size: paginationModel.pageSize,
      page: paginationModel.page,
    };

    GetPaymentWithLinkedList(request, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data?.data);
          setFormValues(request);
          setIsSubmitted(true);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };


  useEffect(() => {

    if (!isSubmitted || !formValues) {
      return;
    }
    const requestPayload = {
      ...formValues,
      ...getQueryParams(queryOptions),
    };

    GetPaymentWithLinkedList(requestPayload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data?.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setTableData(data?.data);
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  }, [queryOptions, paginationModel.page,
    paginationModel.pageSize, GetPaymentWithLinkedList,
    setSnackbar,]);

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    setTableData(undefined);
    const request: IPaymentWithLinkedListRequest = {
      merchantID,
      status,
      size: model.pageSize,
      page: model.page,
      ...getQueryParams(queryOptions),
    };

    GetPaymentWithLinkedList(request, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data?.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };

  const deleteRow = React.useCallback(
    (transaction: any) => () => {
      setIsDeleteModalOpen(true);
      setSelectedRowId(transaction.orderId);
    },
    []
  );

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDeleteConfirm = () => {
    const deleteRequest = { orderId: selectedRowId };

    passiveLinkedPayment(deleteRequest, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseDeleteModal();
  };
  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "actions",
        type: "actions",
        width: 80,
        getActions: (params) => [
          !!showDelete ? (
            <GridActionsCellItem
              label="Sil"
              onClick={deleteRow(params.row)}
              showInMenu
            />
          ) : (
            <></>
          ),
        ],
      },
      { field: "merchantId", headerName: "Üye İşyeri No.", width: 150 },
      { field: "merchantName", headerName: "Üye İşyeri Adı", width: 430 },
      {
        field: "linkCreatedDate",
        headerName: "Link Oluşturma Tarihi",
        width: 220,
      },
      {
        field: "linkExpiredDate",
        headerName: "Link Geçerlilik Tarihi",
        width: 220,
      },
      { renderCell: RenderStatus, field: "status", headerName: "Durum", width: 200 },
      { field: "orderId", headerName: "Sipariş Numarası", width: 300 },
      {
        field: "amount", headerName: "Tutar", width: 150,
        type: 'decimal',
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
      },
    ];
  }, [deleteRow, showDelete]);

  const onSave = () => {
    GetPaymentWithLinkedList(
      {
        size: -1,
        page: 0,
        orderBy: "CreateDate",
        orderByDesc: true,
        merchantID: formValues.merchantID,
        status: formValues.status,
        ...getQueryParams(queryOptions),
      },
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            function fieldValue(data) {
              return data.map((item) => {
                return {
                  "Üye İşyeri No.": item?.merchantId,
                  "Üye İşyeri Adı": item?.merchantName,
                  "Link Oluşturma Tarihi": item?.linkCreatedDate,
                  "Link Geçerlilik Tarihi": item?.linkExpiredDate,
                  "Durum": getStatusLabel(item?.status),
                  "Sipariş Numarası": item?.orderId,
                  "Tutar": item?.amount,
                };
              });
            }
            const refactoredData = fieldValue(data?.data?.result);
            downloadExcel(refactoredData || [], "Linkli Ödeme Listesi");
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      if (filters[key]?.toString()?.length >= 1) {
        queryParams[key] = filters[key];
      }
    }

    return queryParams;
  };

  const handleFilterChange = debounce((filters) => {
    if (filters.clearFilter) {
      return setQueryOptions({});
    }

    const queryParams = getQueryParams(filters);

    const allValuesAtLeastThreeChars = Object.values(queryParams).every((value) => value?.toString().length >= 3);
    const atLeastOneValueThreeChars = Object.values(queryParams).some((value) => value?.toString().length >= 3);

    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;

    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }

    if ((allValuesAtLeastThreeChars || (atLeastOneValueThreeChars && previousKeysLength > currentKeysLength))) {
      setQueryOptions(queryParams);
    }

    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;

  }, 500);
  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
  // Komponent içerisinde
  const previousQueryParams = React.useRef({});

  const [isFilterAccordionExpanded, setFilterAccordionExpand] = useState(true);

  const hasLoading =
    isGetPaymentWithLinkedListLoading || isPassiveLinkedPaymentLoading;
  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} justifyContent="space-between">
        <Stack flex={1} p={2}>
          <BaseFilterTableWithAccordion summary="Linkli Ödeme Listeleme" isExpanded={isFilterAccordionExpanded} setExpanded={setFilterAccordionExpand} setTableVisibility={setShowTable}
            child={<Stack spacing={4}>
              <Stack
                spacing={3}
                direction={isDesktop ? "row" : "column"}
                width={isDesktop ? 1308 : "auto"}
              >
                <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                  {merchantList && (
                    <Controller
                      control={control}
                      name="merchantID"
                      render={() => {
                        return (
                          <>
                            <Autocomplete
                              onChange={(event, selectedValue) => {
                                if (selectedValue) {
                                  setValue("merchantID", selectedValue.value);
                                } else {
                                  setValue("merchantID", 0);
                                }
                              }}
                              id="merchantID"
                              options={merchantList}
                              getOptionLabel={(option: {
                                label: string;
                                value: number;
                              }) => option.label}
                              renderInput={(params) => (
                                <TextField {...params} label="Üye İşyeri" />
                              )}

                            />
                          </>
                        );
                      }}
                    />
                  )}
                </FormControl>
                <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                  {paymentstatusList ? (
                    <Controller
                      name="status"
                      control={control}
                      defaultValue=""
                      render={({ field: { onChange, value } }) => {
                        const selectedStatus = paymentstatusList.find(
                          (option) => option.value === value
                        );

                        return (
                          <Autocomplete
                            id="status"
                            options={paymentstatusList}
                            getOptionSelected={(option, value) =>
                              option.value === value
                            }
                            getOptionLabel={(option) => option.label}
                            value={selectedStatus || null}
                            onChange={(_, newValue) => {
                              onChange(newValue ? newValue.value : "");
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="İşlem Durumu" />

                            )}

                          />

                        );
                      }}
                    />
                  ) : null}
                </FormControl>
              </Stack>
              <Stack
                direction="row"
                justifyContent="flex-end"
                width={isDesktop ? 1308 : "auto"}
              >
                <Button
                  onClick={handleSubmit(onSubmit)}
                  variant="contained"
                  text={"ARA"}
                  sx={{ width: 150 }}
                />
              </Stack>
            </Stack>} />
          <Stack flex={1} mt={2}>
            {showTable && (
              <>
                <Table
                  columnVisibilityConfigKey="paymentWithLinkedColumnVisibilityKey"
                  handleFilterChange={handleFilterChange}
                  hasActiveFilters={hasActiveFilters}
                  paginationModel={paginationModel}
                  onPaginationModelChange={handleChangePagination}
                  paginationMode="server"
                  rowCount={tableData?.totalItems || 0}
                  getRowId={(row) => row?.orderId}
                  sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
                  // autoHeight
                  isRowSelectable={() => false}
                  // disableColumnMenu
                  rows={tableData?.result || []}
                  columns={columns}
                  exportFileName="Linkli Ödeme Listesi"
                  onSave={() => onSave()}
                />
                <DeleteConfirmModal
                  isOpen={isDeleteModalOpen}
                  onClose={handleCloseDeleteModal}
                  onConfirm={() => handleDeleteConfirm()}
                ></DeleteConfirmModal>
              </>
            )}
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
